import { enableProdMode } from '@angular/core'
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic'

import { AppModule } from './app/app.module'
import { environment } from './environments'

import * as Sentry from '@sentry/angular'
import { Integrations } from '@sentry/tracing'


if (environment.production) {
  enableProdMode()
  Sentry.init({
    dsn: 'https://5d2c49c65f37429aa3412f9055b6cb9c@o489531.ingest.sentry.io/5551923',
    autoSessionTracking: true,
    integrations: [
      new Integrations.BrowserTracing({
        tracingOrigins: [ 'https://app.adex.com/' ],
        routingInstrumentation: Sentry.routingInstrumentation
      })
    ],

    // We recommend adjusting this value in production, or using tracesSampler
    // for finer control
    tracesSampleRate: 1.0
  })
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch(err => console.error(err))
